export const POST_ONBOARDING_SETUP_STORAGE_KEY = "softcar_post_onboarding_setup_pending";

export const POST_ONBOARDING_SETUP_EVENT = "softcar:post-onboarding-setup-pending";

export const markPostOnboardingSetupPending = () => {
    sessionStorage.setItem(POST_ONBOARDING_SETUP_STORAGE_KEY, "1");
    window.dispatchEvent(new CustomEvent(POST_ONBOARDING_SETUP_EVENT));
};

export const clearPostOnboardingSetupPending = () => {
    sessionStorage.removeItem(POST_ONBOARDING_SETUP_STORAGE_KEY);
};

export const isPostOnboardingSetupPending = () =>
    sessionStorage.getItem(POST_ONBOARDING_SETUP_STORAGE_KEY) === "1";
